

/**
 * API wrapper for LocalStorage
 */
class LocalStorageAPI {

    private _namespace: string | undefined = undefined;

    private _store = window.localStorage;

    private _ns(): string {
        return this._namespace && this._namespace.length ? `${this._namespace}.` : '';
    }

    public namespace(namespace: string): LocalStorageAPI {
        this._namespace = namespace;
        return this;
    }

    public has(key: string): boolean {
        return !!this.get(key);
    }

    public get(key: string): any {
        try {
            return JSON.parse(this._store.getItem(`${this._ns()}${key}`) + '');
        } catch (e) {
            console.log('LocalStorageAPI::get() Exception: ', e);
        }
    }

    public set(key: string, value: any): void {
        try {
            return this._store.setItem(`${this._ns()}${key}`, JSON.stringify(value));
        } catch (e) {
            console.log('LocalStorageAPI::set() Exception: ', e);
        }
    }

    public remove(key: string): void {
        try {
            return this._store.removeItem(`${this._ns()}${key}`);
        } catch (e) {
            console.log('LocalStorageAPI::remove() Exception: ', e);
        }
    }

}

export default new LocalStorageAPI();
